import api from './api';

export const notificationsService = {
  async getNotifications() {
    try {
      const response = await api.get('/notifications');
      return Array.isArray(response) ? response : [];
    } catch (error) {
      return [];
    }
  },

  async getAllNotifications() {
    try {
      const response = await api.get('/notifications/all');
      return Array.isArray(response) ? response : [];
    } catch (error) {
      return [];
    }
  },

  async markAsRead(notificationId) {
    return api.post(`/notifications/${notificationId}/read`);
  },

  async markAllAsRead() {
    return api.post('/notifications/mark-all-read');
  }
}; 